<template>
	<div id="chapter" v-if="loaded">
		<div class='chapter-list'>
		  <div class='top zhangjie ' v-on:click="goFee(item)" v-for="(item,index) in chapterData" :key="index">
		    <div class="icon-order">{{index+1}}</div>
		    <span>{{item.subject}}</span>
		    <div class='num'>({{item.subject_count}})</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Learn',
	data () {
		return {
			loaded:false,
			chapterData:[]
		}
	},
	created (){
		this.$https.post('/api/chapter/lists',this.$qs.stringify({
			token:this.$store.state.token,
			qcolumn:this.$route.query.qcolumn,
			cartype:this.$route.query.cartype
		})).then((res) => {
			this.chapterData = res.data.data
			this.loaded = true
		},(res) => {
			console.log(res)
		})
	},
	computed: {
	},
	methods:{
		goFee(item){
			this.$router.push({path: '/fee', query: {
				qcolumn:this.$route.query.qcolumn,
				cartype:this.$route.query.cartype,
				chapter:item.id,
				subject_type:'chapter'
			}});
		}
	}
}
</script>
<style scoped>
#chapter{
	background-color:#FFFFFF;
	min-height:100vh;
}
.chapter-list .zhangjie:nth-child(5n+1) .icon-order{
	background:#74e882;
}
.chapter-list .zhangjie:nth-child(5n+2) .icon-order{
	background:#2cd5ff;
}
.chapter-list .zhangjie:nth-child(5n+3) .icon-order{
	background:#ff7387;
}
.chapter-list .zhangjie:nth-child(5n+4) .icon-order{
	background:#f8b551;
}
.chapter-list .zhangjie:nth-child(5n+5) .icon-order{
	background:#cf86f5;
}
.chapter-list{
  display: flex;
  flex-flow: row wrap;
  padding: 0 10px 30px 10px;
}
.chapter-list > div{
  width: 50%;
  display: flex;
  margin-top: 6vw;
  line-height:8vw;
}
.chapter-list > div .icon-order{
  width: 9vw;
  height: 9vw;
  border-radius: 100%;
  text-align: center;
  line-height: 9vw;
  color: #fff;
  font-size: 12px;
  margin-right: 8px;
}
.chapter-list > div text{
  font-size: 14px;
}
.chapter-list > div .num{
  color: #999;
  font-size: 14px;
  margin-left:3px;
}
.greenbg{
  background: #74e882;
}
.bluebg{
  background: #2cd5ff;
}
.redbg{
  background: #ff7387;
}
.yellowbg{
  background: #f8b551;
}
.purplebg{
  background: #cf86f5;
}
</style>


// WEBPACK FOOTER //
// src/components/Chapter.vue